<template>
  <div class="message-view right_auth">
    <div class="theme">我的消息</div>

    <div class="content">
      <div v-if="messages.length"  style="padding-bottom: 20px;">
        <div class="block" v-for="(me,index) in messages" >

          <p class="seconds">{{me.createTime}}</p>
          <div class="message">
            <p class="title">系统消息</p>
            <p class="info">{{me.informationInfo}}</p>
            <i class="close" @click="remove(me.id)"></i>
            <span v-if="me.readStatus == 1" style="color: red">未读</span>
            <span v-else="me.readStatus == 2">已读</span>
          </div>
        </div>
      </div>
      <div class="g_empty" v-if="!messages.length">
        <p class="info">没有相关消息~</p>
      </div>
    </div>
    <div class="page_wrap" style="margin:0 0 80px 10px;">
      <sd-pager :page-data="curPage" @page-change="pageChange"></sd-pager>
    </div>

  </div>
</template>
<script>
  import {util} from '../service/util'
  import sdPager from '../components/sdPager'
  let API = util.api(['GETMYINFORMATION','DELETEMESSAGEBYID']);
  export default{
    components: { sdPager },
    data(){
      return{
        messages:[],
        curPage : {
          kw: '',
          pageNo: 1,
          pageSize: 15,
          totalPage: 1
        },
      }
    },
    computed:{
      getPage(){
        let page = this.curPage;
        return {
          pageNo: page.pageNo,
          pageSize: page.pageSize
        }
      }
    },
    methods:{
      remove(id){
        let _this = this;
        util.kAjax(API.DELETEMESSAGEBYID,{id:id},res=>{
          if(res.status == 1){
            _this.message();
          }
        })
      },
      changeType(){
        this.messages = [];
        // 数据为空，加载数据
        if(!this.messages.length){
          this.message();
        }
      },
      pageChange(index) {
        let page = this.curPage;
        this.message();
      },
      message(){
        let param = {
          page: this.getPage,
        }
        util.kAjax(API.GETMYINFORMATION,param,res=>{
          let page = this.curPage;
          this.messages = [];
          let _data = res.data.datas,
            _page = {
              pageNo:res.data.pageNo,
              totalPage : res.data.totalPage
            }
          this.messages = _data;

          this.curPage.totalPage = _page.totalPage;
          this.curPage.pageNo = _page.pageNo;
        })
      },

    },
    mounted(){

    },
    created() {
      this.changeType();
    }
  }
</script>




// WEBPACK FOOTER //
// MessageView.vue?0dca7ae1